"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _elements = require("../../styles/elements");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Create a component for it, so we can make sure all save buttons have the same styles by default
// even if we didn't use ModalBtns in the Drawer
var SaveBtn = function SaveBtn(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      htmlType = _ref.htmlType,
      form = _ref.form,
      type = _ref.type,
      as = _ref.as,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "onClick", "disabled", "htmlType", "form", "type", "as"]);
  return (0, _jsxRuntime.jsx)(_Button["default"], _objectSpread(_objectSpread({
    type: type,
    onClick: onClick,
    disabled: disabled,
    htmlType: htmlType,
    form: form,
    as: as,
    css: _elements.text.styles.fontMedium,
    className: className
  }, otherProps), {}, {
    children: children
  }));
};

SaveBtn.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node,
  onClick: _propTypes.func,
  disabled: _propTypes.bool,
  type: _propTypes.string,
  form: _propTypes.string,
  htmlType: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  as: _propTypes.string
};
SaveBtn.defaultProps = {
  className: undefined,
  children: undefined,
  onClick: undefined,
  disabled: false,
  htmlType: undefined,
  form: undefined,
  type: 'info',
  as: undefined
};
var _default = SaveBtn;
exports["default"] = _default;
//# sourceMappingURL=SaveBtn.js.map